import './banner-message.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as SuccessSvg } from '../../../../assets/svgs/message-success.svg';
import { ReactComponent as WarningSvg } from '../../../../assets/svgs/message-warning.svg';
import { ReactComponent as ErrorSvg } from '../../../../assets/svgs/message-error.svg';
import { ReactComponent as CloseSvg } from '../../../../assets/svgs/message-close.svg';

const BannerMessage = ({ type, title, description }) => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    isVisible && (
      <div className={classNames('banner-message', `banner-message__${type}`)}>
        <div className="banner-message__icon">
          {type === 'success' && <SuccessSvg />}
          {type === 'warning' && <WarningSvg />}
          {type === 'error' && <ErrorSvg />}
        </div>

        <div className="banner-message__body">
          {title ? (
            <div className="banner-message__body--title">{title}</div>
          ) : null}
          {description ? (
            <div className="banner-message__body--description">
              {description}
            </div>
          ) : null}
        </div>

        <button
          type="button"
          className="banner-message__close"
          onClick={() => setIsVisible(false)}
          aria-label="Close Banner Message Button"
        >
          <CloseSvg />
        </button>
      </div>
    )
  );
};

BannerMessage.propTypes = {
  type: PropTypes.oneOf(['success', 'warning', 'error']).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

BannerMessage.defaultProps = {
  title: '',
  description: '',
};

export default BannerMessage;
